// libs
import React, { Fragment, memo } from 'react';

// styled components
import { Container, StyledProductPlaceholder } from './styles';

const PRODUCTS = [1, 2, 3, 4, 5];
const ROWS = [1, 2, 3, 4];

function WidgetPlaceholder() {
  return (
    <Container>
      {ROWS.map((_, rIdx) => (
        <Fragment key={rIdx}>
          <div className="title" />
          <div className="container">
            <div className="content">
              {PRODUCTS.map((__, idx) => (
                <StyledProductPlaceholder key={idx} />
              ))}
            </div>
          </div>
        </Fragment>
      ))}
    </Container>
  );
}

export default memo(WidgetPlaceholder);
